export default {
  documentContent: state => state.documentContent,
  allClass: state => state.allClass,
  individualClass: state => state.individualClass,
  blacklistedField: state => state.blacklistedField,
};
